var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"XyjBtn",style:(Object.assign({}, {padding: '7px'},_vm.styleObj)),attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"data-perms":_vm.getPerms(),"loading":_vm.load,"disabled":!_vm.hasPerms(_vm.perms)},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05176bb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XyjButton/XyjButton.vue
// module id = null
// module chunks = 